module.exports = __webpack_public_path__ + "img/Excel-RTD.c7410726.png";